<!-- This wrapper determines if fastbooking is inside a regular container or inside a bottom sheet -->
<template>
  <div class="ibh-fastbooking-wrapper">
    <BottomSheet
      v-if="currentDevice.isMobile && !currentPageType.isHome() && !currentSite?.isStaragent"
      id="ibh-fastbooking-container"
      class="ibh-fastbooking-container js-ibh-fastbooking-container"
      :sheet-id="'ibh-fastbooking-main-container'"
      :sheet-class="'ibh-fastbooking-sheet'"
      :is-open="showSticky"
      :title="i18n.fastbooking.mobile.book_your_stay"
      :has-content-padding="false"
      :class="{
        'is-hidden': initiallyHidden,
      }"
      @on-ready="handleBottomSheetReady"
      @on-close="handleHideSticky"
    >
      <template #content>
        <slot></slot>
      </template>
    </BottomSheet>
    <div
      v-else
      id="ibh-fastbooking-container"
      class="ibh-fastbooking-container js-ibh-fastbooking-container"
      :class="{
        'js-keep-hidden is-hidden': initiallyHidden,
      }"
    >
      <button v-if="hasHideStickyButton" class="ibh-fastbooking__close" @click="handleHideSticky">
        <span class="s s-close-fat c-primary"></span>
      </button>
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'

import { currentDevice } from '../../../../core/utils/currentDevice'
import { currentSite } from '../../../../core/utils/currentSite'
import { IBH_FASTBOOKING_EVENTS } from '../../../../shared/fastbooking/constants'
import fastbooking from '../../../../shared/fastbooking/ibh_fastbooking'
import { currentPageType } from '../../../../utils/page_type_detector'
import BottomSheet from '../BottomSheet/BottomSheet.vue'

const props = defineProps({
  initiallyHidden: {
    type: Boolean,
    default: false,
  },
  initiallyStickyHidden: {
    type: Boolean,
    default: false,
  },
  hasHideStickyButton: {
    type: Boolean,
    default: false,
  },
  i18n: {
    type: Object,
    default: () => {},
  },
  alwaysSticky: {
    type: Boolean,
    default: false,
  },
  withTabs: {
    type: Boolean,
    default: true,
  },
})

// -- FASTBOOKING STICKY ---
const isSticky = ref(props.initiallyStickyHidden)
const showSticky = ref(false)

if (!currentPageType.isHome() && currentDevice.isMobile && !currentSite?.isStaragent) {
  isSticky.value = true
} else if (!currentPageType.isHome() && currentDevice.isMobile) {
  isSticky.value = true
}

function handleStickyVersion() {
  document.addEventListener(IBH_FASTBOOKING_EVENTS.OPEN_STICKY_FASTBOOKING, () => {
    if (currentDevice.isMobile) {
      ScrollLock.on()
    }
    setTimeout(() => {
      showSticky.value = true
    }, 300)
  })
  document.addEventListener(IBH_FASTBOOKING_EVENTS.CLOSE_STICKY_FASTBOOKING, () => {
    showSticky.value = false
    if (currentDevice.isMobile) {
      ScrollLock.off()
    }
  })
}

function handleHideSticky() {
  showSticky.value = false
  fastbooking.hideOverlay()
}

onMounted(() => {
  handleStickyVersion()
})

// -- BOTTOM SHEET INSTANCE --
const fbSheetInstance = ref()
const handleBottomSheetReady = sheetInstance => {
  fbSheetInstance.value = sheetInstance
}

// -- FB READY --
document.addEventListener(IBH_FASTBOOKING_EVENTS.FASTBOOKING_READY, () => {
  if (!fbSheetInstance.value) return

  fbSheetInstance.value.calcInitialSheetHeight()
})
</script>

<style lang="scss">
@use '../../../../base_css/abstracts/abstracts.scss' as *;

.ibh-fastbooking-sheet {
  .bottom-sheet__body {
    padding-bottom: 68px;
  }

  .ibh-fastbooking {
    box-shadow: 0;
  }

  .promocode-selector {
    .fb-box {
      border-bottom: 0;
    }
  }

  &.is-visible {
    .search-button {
      position: fixed;
      bottom: 24px;
      z-index: 2;
      width: calc(100% - 42px);
    }
  }
}
</style>
